<div class="support-chat-widget" [class.support-chat-widget--open]="isOpen">
  <div class="support-chat-panel" [class.support-chat-panel--wide]="view === 'create-ticket'"
    [class.support-chat-panel--menu]="view === 'menu'" *ngIf="isOpen">
    <div class="support-chat-panel-header" [class.support-chat-panel-header--hero]="view === 'menu'">
      <button type="button" class="support-chat-back" *ngIf="view !== 'menu'" (click)="goBack()" aria-label="Back">
        <i class="mdi mdi-arrow-left"></i>
      </button>
      <div class="support-chat-header-text">
        <span class="support-chat-header-title">
          {{ view === 'chat' ? (isSalesPerson ? (discussionId !== null ? (activeThreadLabel() || 'Chat') : 'Clients') : 'Chat') : view === 'tickets' ? 'Tickets' : view === 'create-ticket' ? 'New Ticket' : 'Support' }}
        </span>
        <span class="support-chat-header-sub">
          {{ view === 'menu' ? 'How can we help you today?' : view === 'chat' ? (isSalesPerson ? (discussionId !== null ? 'Client conversation' : 'Your assigned clients') : 'Your conversation with Advin support') : view === 'tickets' ? 'Track your support requests' : 'Tell us what went wrong' }}
        </span>
      </div>
      <button type="button" class="support-chat-close" (click)="dismiss()" aria-label="Close">
        <i class="mdi mdi-close"></i>
      </button>
    </div>

    <!-- Menu view -->
    <div class="support-chat-panel-body" *ngIf="view === 'menu'">
      <button type="button" class="support-chat-option" (click)="openView('chat')">
        <span class="support-chat-option-icon support-chat-option-icon--chat">
          <i class="mdi mdi-chat-processing-outline"></i>
        </span>
        <span class="support-chat-option-text">
          <span class="support-chat-option-title">{{ isSalesPerson ? 'Chat with clients' : 'Chat with us' }}</span>
          <span class="support-chat-option-desc">{{ isSalesPerson ? 'Reply to your assigned clients in real time' : 'Message your account manager in real time' }}</span>
        </span>
        <i class="mdi mdi-chevron-right support-chat-option-chevron"></i>
      </button>
      <button type="button" class="support-chat-option" (click)="openView('tickets')" *ngIf="!isSalesPerson">
        <span class="support-chat-option-icon support-chat-option-icon--ticket">
          <i class="mdi mdi-ticket-confirmation-outline"></i>
        </span>
        <span class="support-chat-option-text">
          <span class="support-chat-option-title">Tickets</span>
          <span class="support-chat-option-desc">Raise a request or track an existing one</span>
        </span>
        <i class="mdi mdi-chevron-right support-chat-option-chevron"></i>
      </button>
      <div class="support-chat-tip" [style.--tip-start]="menuTipStart">
        <i class="mdi mdi-lightbulb-on-outline"></i>
        <span class="support-chat-tip-rotator">
        <span class="support-chat-tip-text" style="--i: 0">Reporting a problem? Attach a screenshot in Chat so we can see exactly what you see.</span>
        <span class="support-chat-tip-text" style="--i: 4">Pick the right project when raising a ticket so it reaches the right team first.</span>
        <span class="support-chat-tip-text" style="--i: 2">A short, specific ticket title like "GST wrong on inter-state invoice" gets routed faster.</span>
        <span class="support-chat-tip-text" style="--i: 1">Use the camera button in Chat to capture the page you're on, with no extra steps.</span>
        <span class="support-chat-tip-text" style="--i: 3">When you raise a ticket, include the steps you took and what you expected to happen.</span>
        <span class="support-chat-tip-text" style="--i: 5">Select any ticket to open its full conversation and see every update.</span>
        <span class="support-chat-tip-text" style="--i: 6">One issue per ticket keeps things clear. Raise a separate ticket for each problem.</span>
        <span class="support-chat-tip-text" style="--i: 7">Facing issue &amp; not sure where to start? Just say hello in Chat and we'll take it from there.</span>
        <span class="support-chat-tip-text" style="--i: 8">The Tickets tabs separate Active, In Progress and Closed requests, so you can see what's being worked on.</span>
        <span class="support-chat-tip-text" style="--i: 9">Include the screen name or document number in your message so we can find it quickly.</span>
        </span>
      </div>
    </div>

    <!-- Tickets view: real data (spd.SupportTickets_ReadByTicketOwner) -->
    <div class="support-chat-tickets" *ngIf="view === 'tickets'">
      <div class="support-chat-tickets-toolbar">
        <div class="support-chat-tabs" role="tablist">
          <button type="button" *ngFor="let tab of ticketTabs" class="support-chat-tab" role="tab"
            [class.active]="activeTicketTab === tab" (click)="setTicketTab(tab)">
            {{ tab === 'InProgress' ? 'In Progress' : tab }}
          </button>
        </div>
      </div>
      <div class="support-chat-ticket-list">
        <div class="support-chat-skeleton-list" *ngIf="ticketsLoading[activeTicketTab]" aria-label="Loading tickets">
          <div class="support-chat-skeleton" *ngFor="let n of [1, 2, 3]">
            <span class="support-chat-skeleton-line support-chat-skeleton-line--short"></span>
            <span class="support-chat-skeleton-line"></span>
            <span class="support-chat-skeleton-line support-chat-skeleton-line--mid"></span>
          </div>
        </div>
        <ng-container *ngIf="!ticketsLoading[activeTicketTab]">
          <div class="support-chat-list-hint" *ngIf="tickets[activeTicketTab]?.length">
            Select a ticket to view its full conversation.
          </div>
          <a href="javascript:void(0)" class="support-chat-ticket-row"
            [class]="'status-' + (ticket.ticketStatus || 'open').toLowerCase()"
            *ngFor="let ticket of tickets[activeTicketTab]" (click)="goToTicket(ticket)">
            <span class="support-chat-ticket-title" [attr.title]="ticket.title">{{ ticket.title }}</span>
            <span class="support-chat-status-badge" [class]="'status-' + (ticket.ticketStatus || 'open').toLowerCase()">
              {{ ticket.ticketStatus || 'Open' }}
            </span>
            <span class="support-chat-ticket-date">{{ ticket.createdOn | date:'d MMM y' }}</span>
            <i class="mdi mdi-chevron-right support-chat-ticket-chevron"></i>
          </a>
          <div class="support-chat-empty-state" *ngIf="!tickets[activeTicketTab]?.length">
            <span class="support-chat-empty-icon">
              <i class="mdi" [class.mdi-inbox-outline]="activeTicketTab === 'Active'"
                [class.mdi-timer-sand]="activeTicketTab === 'InProgress'"
                [class.mdi-check-circle-outline]="activeTicketTab === 'Closed'"></i>
            </span>
            <span class="support-chat-empty-title">
              {{ activeTicketTab === 'Active' ? 'No active tickets' : activeTicketTab === 'InProgress' ? 'Nothing in progress' : 'No closed tickets yet' }}
            </span>
            <span class="support-chat-empty-text">
              {{ activeTicketTab === 'Active' ? 'You are all caught up. Need a hand with something? Raise a new ticket below.' : activeTicketTab === 'InProgress' ? 'Tickets our team is currently working on will appear here.' : 'Resolved tickets are kept here for your reference.' }}
            </span>
          </div>
        </ng-container>
      </div>
      <div class="support-chat-tickets-footer">
        <button type="button" class="support-chat-new-ticket-btn" (click)="openCreateTicket()">
          <i class="mdi mdi-plus"></i> New Ticket
        </button>
      </div>
    </div>

    <!-- Create Ticket view: Title / Project / Description only, real SupportTicket_Create -->
    <form class="support-chat-create-ticket" *ngIf="view === 'create-ticket'" [formGroup]="createTicketForm"
      (ngSubmit)="submitCreateTicket()">
      <div class="support-chat-form-fields">
        <div class="support-chat-field">
          <label>Title <span class="support-chat-required">*</span></label>
          <input type="text" formControlName="title" placeholder="e.g. Invoice print shows the wrong GST amount" />
          <div class="support-chat-field-hint"
            *ngIf="!(createTicketForm.controls.title.invalid && createTicketForm.controls.title.touched)">
            A short, specific summary helps us route it faster.
          </div>
          <div class="support-chat-field-error"
            *ngIf="createTicketForm.controls.title.invalid && createTicketForm.controls.title.touched">
            <i class="mdi mdi-alert-circle-outline"></i> Title is required.
          </div>
        </div>

        <div class="support-chat-field">
          <label>Project <span class="support-chat-required">*</span></label>
          <select formControlName="projectId">
            <option [ngValue]="null" disabled>— Select a project —</option>
            <option *ngFor="let project of projects" [ngValue]="project.projectId">{{ project.pName }}</option>
          </select>
          <div class="support-chat-field-hint"
            *ngIf="!(createTicketForm.controls.projectId.invalid && createTicketForm.controls.projectId.touched)">
            Pick the product or module the issue belongs to.
          </div>
          <div class="support-chat-field-error"
            *ngIf="createTicketForm.controls.projectId.invalid && createTicketForm.controls.projectId.touched">
            <i class="mdi mdi-alert-circle-outline"></i> Project is required.
          </div>
        </div>

        <div class="support-chat-field">
          <label>Description</label>
          <app-rich-text-editor [control]="createTicketForm.controls.description"></app-rich-text-editor>
          <div class="support-chat-field-hint">
            What happened, what you expected, and the steps to reproduce it.
          </div>
        </div>

        <div class="support-chat-field-error support-chat-form-error" *ngIf="createTicketError">
          <i class="mdi mdi-alert-circle-outline"></i> Couldn't create the ticket. Please try again.
        </div>
      </div>

      <div class="support-chat-form-actions">
        <button type="button" class="support-chat-create-cancel" (click)="goBack()" [disabled]="creatingTicket">
          Cancel
        </button>
        <button type="submit" class="support-chat-create-submit" [disabled]="creatingTicket">
          <i class="mdi mdi-loading mdi-spin" *ngIf="creatingTicket"></i>
          {{ creatingTicket ? 'Creating…' : 'Create Ticket' }}
        </button>
      </div>
    </form>

    <!-- Chat view: real DiscussionMaster/DiscussionDetail + SignalR -->
    <div class="support-chat-thread" *ngIf="view === 'chat'">

      <!-- SalesPerson, no thread open: WhatsApp-style list of assigned
           clients. All their threads are already joined live at once via
           JoinAllMyDiscussionsAsSalesPerson, so opening one is instant. -->
      <ng-container *ngIf="isSalesPerson && discussionId === null">
        <div class="support-chat-thread-search" *ngIf="salesPersonThreads.length">
          <i class="mdi mdi-magnify"></i>
          <input type="text" [(ngModel)]="threadSearchQuery" placeholder="Search your clients…" />
          <button type="button" *ngIf="threadSearchQuery" (click)="threadSearchQuery = ''" aria-label="Clear search">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
        <div class="support-chat-client-list">
          <div class="support-chat-empty" *ngIf="chatLoading">
            <i class="mdi mdi-loading mdi-spin"></i> Loading your clients…
          </div>
          <ng-container *ngIf="!chatLoading">
            <button type="button" class="support-chat-client-row" *ngFor="let thread of filteredSalesPersonThreads"
              (click)="openThread(thread)">
              <span class="support-chat-client-avatar">{{ clientInitial(thread.clientCompanyName) }}</span>
              <span class="support-chat-client-info">
                <span class="support-chat-client-name">{{ thread.clientCompanyName || ('Company #' + thread.fromTenantId) }}</span>
                <span class="support-chat-client-time" *ngIf="thread.lastActivityOn; else notStarted">{{ thread.lastActivityOn | date:'d MMM, h:mm a' }}</span>
                <ng-template #notStarted><span class="support-chat-client-time">No messages yet</span></ng-template>
              </span>
              <span class="support-chat-client-unread" *ngIf="unreadCountFor(thread) as count">{{ count }}</span>
            </button>
            <div class="support-chat-empty-state" *ngIf="!salesPersonThreads.length">
              <span class="support-chat-empty-icon"><i class="mdi mdi-account-group-outline"></i></span>
              <span class="support-chat-empty-title">No clients yet</span>
              <span class="support-chat-empty-text">No clients assigned to you yet.</span>
            </div>
            <div class="support-chat-empty-state" *ngIf="salesPersonThreads.length && !filteredSalesPersonThreads.length">
              <span class="support-chat-empty-icon"><i class="mdi mdi-magnify"></i></span>
              <span class="support-chat-empty-title">No matches</span>
              <span class="support-chat-empty-text">No clients match "{{ threadSearchQuery }}".</span>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <!-- A client's own single thread, or a SalesPerson's currently-open one -->
      <ng-container *ngIf="!isSalesPerson || discussionId !== null">
        <div class="support-chat-messages" #messagesEl (scroll)="onMessagesScroll($event)">
          <div class="support-chat-empty" *ngIf="chatLoading">
            <i class="mdi mdi-loading mdi-spin"></i> Loading…
          </div>
          <div class="support-chat-empty" *ngIf="loadingOlderMessages">
            <i class="mdi mdi-loading mdi-spin"></i> Loading older messages…
          </div>
          <ng-container *ngFor="let msg of chatMessages; let i = index">
            <div class="support-chat-date-separator" *ngIf="isNewDay(i)">{{ dateSeparatorLabel(msg.createdOn) }}</div>
            <div class="support-chat-message" [class.from-me]="msg.fromMe">
              <span class="support-chat-message-avatar" *ngIf="!msg.fromMe">{{ clientInitial(msg.senderName) }}</span>
              <div class="support-chat-message-content">
                <div class="support-chat-message-sender">
                  {{ msg.fromMe ? 'You' : msg.senderName }}
                  <span class="support-chat-message-time" *ngIf="msg.createdOn">{{ msg.createdOn | date:'h:mm a' }}</span>
                  <i class="mdi support-chat-read-receipt" *ngIf="msg.fromMe" [class.mdi-check]="!msg.isRead"
                    [class.mdi-check-all]="msg.isRead" [class.read]="msg.isRead"
                    [attr.aria-label]="msg.isRead ? 'Read' : 'Sent'"></i>
                </div>
                <div class="support-chat-message-bubble" [innerHTML]="msg.html"></div>
              </div>
            </div>
          </ng-container>
          <div class="support-chat-empty-state support-chat-empty-state--chat" *ngIf="!chatLoading && !chatMessages.length">
            <span class="support-chat-empty-icon"><i class="mdi mdi-message-text-outline"></i></span>
            <span class="support-chat-empty-title">No messages yet — say hello!</span>
            <span class="support-chat-empty-text">Describe what you need help with. You can add a screenshot or console logs so we can see exactly what you see.</span>
            <span class="support-chat-quick-actions">
              <button type="button" class="support-chat-quick-chip" (click)="captureScreenshot()"
                [disabled]="capturingScreenshot || discussionId === null">
                <i class="mdi mdi-camera-outline"></i> Attach screenshot
              </button>
              <button type="button" class="support-chat-quick-chip" (click)="attachConsoleLogs()"
                [disabled]="capturingLogs || discussionId === null">
                <i class="mdi mdi-bug-outline"></i> Attach console logs
              </button>
            </span>
          </div>
        </div>

        <div class="support-chat-attachments" *ngIf="attachedScreenshotUrl || attachedLogUrl || capturingScreenshot || capturingLogs">
          <div class="support-chat-attachment-chip" *ngIf="capturingScreenshot">
            <i class="mdi mdi-loading mdi-spin"></i> Capturing screenshot…
          </div>
          <div class="support-chat-attachment-chip" *ngIf="attachedScreenshotUrl">
            <img [src]="attachedScreenshotUrl" alt="Screenshot preview" />
            <span>Screenshot</span>
            <button type="button" (click)="removeAttachedScreenshot()" aria-label="Remove screenshot">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
          <div class="support-chat-attachment-chip" *ngIf="capturingLogs">
            <i class="mdi mdi-loading mdi-spin"></i> Preparing log file…
          </div>
          <div class="support-chat-attachment-chip" *ngIf="attachedLogUrl">
            <i class="mdi mdi-file-document-outline"></i>
            <span>{{ attachedLogName }}</span>
            <button type="button" (click)="removeAttachedLog()" aria-label="Remove log file">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
        </div>

        <div class="support-chat-input-row">
          <button type="button" class="support-chat-attach-btn" (click)="captureScreenshot()"
            [disabled]="capturingScreenshot" aria-label="Attach a screenshot of this page" title="Attach screenshot">
            <i class="mdi mdi-camera-outline"></i>
          </button>
          <button type="button" class="support-chat-attach-btn" (click)="attachConsoleLogs()"
            [disabled]="capturingLogs" aria-label="Attach console logs" title="Attach console logs">
            <i class="mdi mdi-bug-outline"></i>
          </button>
          <input type="text" class="support-chat-input" placeholder="Type a message or paste a screenshot…"
            [(ngModel)]="messageText" [disabled]="discussionId === null" (keyup.enter)="sendMessage()" (paste)="onPaste($event)" />
          <button type="button" class="support-chat-send" (click)="sendMessage()" aria-label="Send"
            [disabled]="discussionId === null || sendingMessage || (!messageText.trim() && !attachedScreenshotUrl && !attachedLogUrl)">
            <i class="mdi" [class.mdi-send]="!sendingMessage" [class.mdi-loading]="sendingMessage" [class.mdi-spin]="sendingMessage"></i>
          </button>
        </div>
        <div class="support-chat-composer-hint">Press Enter to send · Win+Shift+S to capture, then paste</div>
      </ng-container>
    </div>
  </div>

  <div class="support-chat-launcher" #launcherEl *ngIf="!launcherHidden"
    [class.support-chat-launcher--enter]="launcherEntering">
    <button type="button" class="support-chat-fab" [class.support-chat-fab--open]="isOpen" (click)="toggleOpen()" aria-label="Support">
      <ng-container *ngIf="!isOpen">
        <span class="support-chat-fab-avatar">
          <img src="assets/icons/icon-72x72.png" alt="" class="support-chat-fab-icon" />
          <span class="support-chat-fab-badge">
            <i class="mdi mdi-headset"></i>
          </span>
        </span>
      </ng-container>
      <i class="mdi mdi-close" *ngIf="isOpen"></i>
      <span class="support-chat-fab-unread-dot" *ngIf="unreadThreadIds.size > 0" [attr.aria-label]="unreadThreadIds.size + ' unread'">{{ unreadThreadIds.size }}</span>
    </button>
    <button type="button" class="support-chat-fab-dismiss" *ngIf="!isOpen" (click)="dismissLauncher($event)"
      aria-label="Hide support button" title="Hide (find it again under your profile &gt; Help &amp; Support)">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
</div>
